

















import Vue from 'vue'
import { Component, Emit } from 'vue-property-decorator'
@Component({})
export default class AppSearchBtn extends Vue {
  @Emit('submit')
  submit () {
    // do nothing
  }
}
